module.exports = __webpack_public_path__ + "static/media/Roof-Garden.d0939d6e.webp";